module.exports = __webpack_public_path__ + "static/media/lBarletta.9d67c910.jpeg";